import s from './Arrow.module.css';

export const Arrow = () => <span className={s.arrow}></span>;
